import React, { useState, useEffect } from "react";
import {
    MDBBreadcrumb, MDBBreadcrumbItem, MDBBtn, MDBCol, MDBDatatable, MDBIcon, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader,
    MDBModalTitle, MDBSelect, MDBTable, MDBTableBody, MDBTableHead, MDBTabs, MDBTabsContent, MDBTabsItem,
    MDBTabsLink, MDBTabsPane
} from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { getAccountLevelPagingGroupsList } from "../../../apiclients/streamsapi_bridge";
export default function AddPagingGroupInAutoDeviceSettingsPopup(props) {
    const [pagingGroupsListdata, setPagingGroupsListdata] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        if (props.pagingGroups) {
            const filteredGroups = props.pagingGroups.filter(group => {
                return !props.existPagingList.some(existing => existing.paging_id == group.paging_id);
            });
            setPagingGroupsListdata(filteredGroups);
        }
    }, [props.pagingGroups, props.existPagingList]);

    const [formData, setFormData] = useState({
        group_name: '',
        group_no: '',
        send_receive: "3",
        paging_id: ''
    });

    useEffect(() => {
        if (pagingGroupsListdata.length > 0) {
            setFormData({
                group_name: pagingGroupsListdata[0].group_name,
                group_no: pagingGroupsListdata[0].group_no,
                send_receive: "3",
                paging_id: pagingGroupsListdata[0].paging_id
            });
        }
    }, [pagingGroupsListdata]);

    const handleSelectChange = (e) => {
        const selectedGroupNo = e.target.value;
        const selectedGroup = pagingGroupsListdata.find(group => group.group_no === selectedGroupNo * 1);

        setFormData({
            group_name: selectedGroup.group_name,
            group_no: selectedGroup.group_no,
            send_receive: "3",
            paging_id: selectedGroup.paging_id
        });
    };

    const handleChangeSendRecieve = (e) => {
        const selectedSendRecieve = e.target.value;
        setFormData({
            ...formData,
            send_receive: selectedSendRecieve,
        });
    };

    return (
        <React.Fragment>
            <div className="pb-3">
                <div className="tel-numbers">
                    <strong>{t("PagingGroup")}</strong>
                </div>
                <div className="form pt-1">
                    <select
                        className="form-control form-select selectname w-100"
                        onChange={handleSelectChange}
                        value={formData.group_no} // Ensure selected value matches the form data
                    >
                        {pagingGroupsListdata.map((data) => (
                            <option key={data.group_no} value={data.group_no}>
                                {data.group_name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="tel-numbers mt-2">
                    <strong>{t("GroupID")}</strong>
                </div>
                <div className="form mt-3">
                    <input type="text" className="w-100" readOnly value={formData.group_no} />
                </div>

                <div className="tel-numbers mt-2">
                    <strong>{t("SendandReceive")}</strong>
                </div>
                <div className="form pt-1 ">
                    <select className="form-control form-select selectname w-100" defaultValue={formData.send_receive} onChange={handleChangeSendRecieve}>
                        <option value="1">Send</option>
                        <option value="2">Receive</option>
                        <option value="3">Both</option>
                    </select>
                </div>
            </div>

            <div className="modal-footer">
                <button onClick={(e) => props.onClose(e)}
                    type="button"
                    className="btn btn-secondary"
                    data-mdb-dismiss="modal"
                >
                    {t("close")}
                </button>
                <button type="button" className="btn green-button" onClick={(e) => { props.onSave(formData) }}>
                    {t('add')}
                </button>
            </div>
        </React.Fragment>
    );
}